const RANK_STYLES = {
  member: { backgroundColor: "var(--rank-member)", color: "var(--rank-text-light)" },
  executive: { backgroundColor: "var(--rank-executive)", color: "var(--rank-text-light)" },
  elite: { backgroundColor: "var(--rank-elite)", color: "var(--rank-text-light)" },
  premier: { backgroundColor: "var(--rank-premier)", color: "var(--rank-text-light)" },
  silver: { backgroundColor: "var(--rank-silver)", color: "var(--rank-text-light)" },
  gold: { backgroundColor: "var(--rank-gold)", color: "var(--rank-text-light)" },
  platinum: { backgroundColor: "var(--rank-platinum)", color: "var(--rank-text-light)" },
  diamond: { backgroundColor: "var(--rank-diamond)", color: "var(--rank-text-light)" },
  blue_diamond: { backgroundColor: "var(--rank-blue-diamond)", color: "var(--rank-text-light)" },
  presidential: { backgroundColor: "var(--rank-presidential)", color: "var(--rank-text-light)" },
};

const RANK_LABELS = {
  member: "Membru",
  executive: "Executive",
  elite: "Elite",
  premier: "Premier",
  silver: "Silver",
  gold: "Gold",
  platinum: "Platinum",
  diamond: "Diamond",
  blue_diamond: "Blue D",
  presidential: "Presidential",
};

const normalizeRank = (rank) => {
  const normalized = String(rank || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  const aliases = {
    basic: "member",
    membru: "member",
    echipa: "executive",
    blue_d: "blue_diamond",
    bluediamond: "blue_diamond",
    presidential_diamond: "presidential",
  };

  return aliases[normalized] || normalized || "member";
};

export const getRankStyle = (rank) => {
  const style = RANK_STYLES[normalizeRank(rank)] || RANK_STYLES.member;
  return { ...style, borderColor: style.backgroundColor };
};

export const getRankColor = (rank) => getRankStyle(rank).backgroundColor;

export const getRankLabel = (rank) =>
  RANK_LABELS[normalizeRank(rank)] || String(rank || RANK_LABELS.member);

export const RANK_OPTIONS = [
  { value: "Membru", label: "Membru" },
  { value: "Executive", label: "Executive" },
  { value: "Elite", label: "Elite" },
  { value: "Premier", label: "Premier" },
  { value: "Silver", label: "Silver" },
  { value: "Gold", label: "Gold" },
  { value: "Platinum", label: "Platinum" },
  { value: "Diamond", label: "Diamond" },
  { value: "Blue Diamond", label: "Blue D" },
  { value: "Presidential Diamond", label: "Presidential" },
].map((rank) => ({ ...rank, ...getRankStyle(rank.value) }));
